import React from 'react';

function LocationMapSection() {
  return (
    <section className="location-map-section">
      <div className="container location-map-container">
        <div className="map-wrapper">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3618.0296495737743!2d67.0339163759539!3d24.931059842427786!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3eb33f0bc6ed04ef%3A0xc685c1a617919122!2sExperts%20Communication!5e0!3m2!1sen!2s!4v1785963900882!5m2!1sen!2s"
            width="100%"
            height="450"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="strict-origin-when-cross-origin"
            title="Experts Communication Location Map"
          ></iframe>
        </div>
      </div>
    </section>
  );
}

export default LocationMapSection;
